import BaseService from '../base-service';
import StandardResponse from './../../models/standard-response';
import { IDriverGroup, IDriverGroupList, IGroupDriverList } from 'models/driverGroup';

export default class DriverGroupService {
    addDriverGroup = async (data: any): Promise<StandardResponse<IDriverGroup>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group`,
                method: 'post',
                data,
            });
            return new StandardResponse<IDriverGroup>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateDriverGroup = async (data: any, id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}`,
                method: 'put',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    enableOrDisableDriverGroup = async (data: any, id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}`,
                method: 'patch',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverGroup = async (id: number): Promise<StandardResponse<IDriverGroup>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}`,
                method: 'get',
            });
            return new StandardResponse<IDriverGroup>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deleteDriverGroup = async (id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}`,
                method: 'delete',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    searchDriverGroup = async (data: any): Promise<StandardResponse<IDriverGroupList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/search`,
                method: 'post',
                data,
            });
            return new StandardResponse<IDriverGroupList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getGroupDriverList = async (data: any, id: number): Promise<StandardResponse<IGroupDriverList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}/access`,
                method: 'post',
                data,
            });
            return new StandardResponse<IGroupDriverList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deleteDriverFromGroup = async (id: number, driverId: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}/access/${driverId}`,
                method: 'delete',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    addGroupDrivers = async (data: any, id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/group/${id}/access`,
                method: 'put',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
